<script setup>
import {useModalStore} from "../../../store/modal";
import {useTicketStore} from "../../../store/tickets";
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";

const loading = ref(false)
const route = useRoute()
const ticketStore = useTicketStore()
const modalStore = useModalStore()
const is_complete = ref(false)
const reload = computed(() => is_complete.value && route.name !== 'tickets-single')

const completeTicket = async () => {
    loading.value = true
    await ticketStore.completeTicket(modalStore.props.id)
    loading.value = false
    is_complete.value = true
}

onMounted(async () => {
    loading.value = true
    await ticketStore.getTicket(modalStore.props.id)
    loading.value = false
    if (ticketStore.ticket?.status === 'complete') {
        is_complete.value = true
    }
})
</script>

<template>
    <DefaultModalBase :heading="!is_complete ? 'Are you sure you want to close this ticket?' : 'Ticket completed.'" icon="check-all" :loading :refresh="reload">

        <div class="kayako-reminder">
            <strong>Don't forget Kayako.</strong>
            <p>Completing this ticket here does not close it in Kayako. Please also close the ticket there.</p>
<!--            <a v-if="ticketStore.ticket?.external_url" :href="ticketStore.ticket.external_url" target="_blank" rel="noopener noreferrer">-->
<!--                Open ticket in Kayako-->
<!--                <ah-icon name="arrow-in" />-->
<!--            </a>-->
        </div>

        <div class="complete-ticket-actions">
            <brand-button @click="completeTicket()" v-if="!is_complete">Yes, mark as complete</brand-button>
            <brand-button variant="secondary" @click="modalStore.close(reload)">{{ !is_complete ? "Nevermind" : "Done" }}</brand-button>
        </div>
    </DefaultModalBase>
</template>

<style scoped lang="scss">
.kayako-reminder {
    margin-bottom: 2rem;
    padding: 2rem;
    border-radius: 1.6rem;
    //background: var(--color-grey-hazy);

    strong {
        color: #FFFFFF;
        @include font(1.4, 1.4, black);
    }

    p {
        margin: .8rem 0;
        @include font(1.3, 1.6, book);
    }

    a {
        display: inline-flex;
        align-items: center;
        gap: .5rem;
        color: var(--color-tiffany-dark);
        @include font(1.3, 1.4, black);
    }
}

.complete-ticket-actions {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
